import AppLayout from '@/modules/shared/layouts/AppLayout.vue';
import SettingsLayout from '@/modules/global-settings/layout/SettingsLayout.vue';

import HelpCenterRoutes from '@/modules/shared/routes';
import GlobalSettingsRoutes from '@/modules/global-settings/routes';

import AMLProModuleRoutes from '@/modules/amlpro/routes';
import IFRS9ModuleRoutes from '@/modules/ifrs9/routes';
import LoanProModuleRoutes from '@/modules/loanpro/routes';
import OnBoarderModuleRoutes from '@/modules/onboarder/routes';
import DelinquencyModuleRoutes from '@/modules/delinquency/routes';
import CRMProModuleRoutes from '@/modules/cmr-pro/routes';
import GeneralLedgerModule from '@/modules/general-ledger/routes';
import GeneralReportModule from '@/modules/reports/routes';
import CreditScoringRoutes from '@/modules/credit-scoring/routes';
import PDModuleRoutes from '@/modules/pd/routes';

let routes = [
  {
    path: 'app/',
    name: 'app',
    component: AppLayout,
    redirect: {
      name: 'central'
    },
    children: [
      // User will be redirected here if they do not have access/certain privileges to a module
      {
        path: 'no-module-access',
        name: 'no-module-access',
        component: () =>
          import('@/modules/shared/views/app/ModuleNotAllowed.vue')
      },
      {
        path: 'two-factor-setup',
        name: 'two-factor-setup',
        component: () => import('@/modules/shared/views/app/TwoFactorSetup.vue')
      },
      {
        path: 'central',
        name: 'central',
        component: () => import('@/modules/shared/views/app/CentralPage.vue')
      },
      {
        path: 'audit-reports',
        name: 'audit-reports',
        meta: {
          //requiredPrivileges: ['View Audit Reports']
        },
        component: () =>
          import('@/modules/shared/views/AuditReports/Reports.vue')
      },
      {
        path: 'audit-reports/user',
        name: 'audit-reports-user',
        component: () =>
          import('@/modules/shared/views/AuditReports/UserStat.vue')
      },
      // {
      //   path: 'mass-upload/',
      //   name: 'mass-upload',
      //   meta: {
      //     requiresAuth: false,
      //     //requiredPrivileges: ['System Settings']
      //   },
      //   component: () => import('@/modules/shared/views/MassUpload.vue')
      // },
      {
        path: 'loan-editor/',
        name: 'loan-editor',
        meta: {
          requiresAuth: false,
          requiredPrivileges: ['System Settings', 'Manage Loan']
        },
        component: () => import('@/modules/shared/views/LoanEditor.vue')
      },
      {
        path: 'reported-issues/',
        name: 'reported-issues',
        meta: {
          //requiredPrivileges: ['System Settings']
        },
        component: () => import('@/modules/shared/views/ReportedIssues.vue')
      }
    ]
  },
  // OnBoarder module routes(Not the settings/config)
  OnBoarderModuleRoutes,
  // LoanPro module routes(Not the settings/config)
  LoanProModuleRoutes,
  // Delinquency module routes(Not the settings/config)
  DelinquencyModuleRoutes,
  // AMLPro module routes(Not the settings/config)
  AMLProModuleRoutes,
  IFRS9ModuleRoutes,
  // CRMPro module routes(Not the settings/config)
  CRMProModuleRoutes,
  GeneralLedgerModule,
  GeneralReportModule,
  CreditScoringRoutes,
  PDModuleRoutes,
  {
    path: 'settings/',
    name: 'settings',
    meta: {
      //requiredPrivileges: ['System Settings'],
      requiresAuth: false,
    },

    component: SettingsLayout,
    redirect: {
      name: 'company'
    },
    // Routes for settings/config
    children: [...GlobalSettingsRoutes]
  },
  {
    path: 'help-center/',
    name: 'help-center',
    meta: {
      requiresAuth: false
    },
    component: () =>
      import('@/modules/shared/components/helpcenter/HelpCenterLayout.vue'),
    redirect: { name: 'index' },
    children: HelpCenterRoutes
  }
];

export default routes;
